import type { BlockType } from '@/api/courses';
import { tfNotGivenAllowed } from '@/lib/trueFalse';

import { blockDefByPick, blockRegistryByType, type BlockDef } from './blockRegistry';

/**
 * Запись реестра для уже созданного блока: вариант узнаётся по содержимому.
 * True / False (`not_given: false`) в шапке блока называется так же, как плитка палитры, а не
 * «True / False / Not Given» (слово владельца 17.10.2026). Включил автор Not Given — шапка прежняя.
 *
 * Отдельным файлом, а не в blockRegistry.tsx: файл с компонентами не должен экспортировать функции
 * (react-refresh/only-export-components) — иначе новое предупреждение линта.
 */
export const blockDefForBlock = (type: BlockType, content: unknown): BlockDef =>
  type === 'true_false_ng' && !tfNotGivenAllowed(content) ? blockDefByPick('true_false') : blockRegistryByType[type];
